import config from '@/config';
import { renderImage } from '@rafflebox-technologies-inc/frontend-lib';

const settings = {
  raffleboxImagesUrl: config.RAFFLEBOX_IMAGES_URL as string
};

export default renderImage(settings);
